
      var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgInfo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 6,
  stroke: "#4A4A4A",
  strokeWidth: 1.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 11.25,
  r: 0.75,
  fill: "#4A4A4A"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 9v-.5a1.75 1.75 0 1 0-1.75-1.75",
  stroke: "#4A4A4A",
  strokeWidth: 1.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

      const __svgRaw = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<circle cx=\"8\" cy=\"8\" r=\"6\" stroke=\"#4A4A4A\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<circle cx=\"8\" cy=\"11.25\" r=\"0.75\" fill=\"#4A4A4A\"/>\r\n<path d=\"M8 9V8.5C8.9665 8.5 9.75 7.7165 9.75 6.75C9.75 5.7835 8.9665 5 8 5C7.0335 5 6.25 5.7835 6.25 6.75\" stroke=\"#4A4A4A\" stroke-width=\"1.2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/info.940671d8694abd4c04a904d5675a5ef6.svg"),
        {
          React: SvgInfo,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      